import React from 'react';
import Button from '../../../../muiComponents/Button';
import useTranslate from '../../../../customHooks/useTranslate';
import { requestConnectionToMember } from '../../../../services/zinantis/members/zinantisMemberListServices';
import { useNotification } from '../../../../contexts/NotificationsContext';
import { IZinantisConnectionRequest } from '../../../../types/entities/IZinantisConnectionRequest';
import { FeedbackMessages } from '../../../../utils/commonVariables/messages';

interface RequestConnectionButtonProps {
    idAgency: string;
    onChangeLoading: (isLoading: boolean) => void;
    onRequestSuccess: (newRequest: IZinantisConnectionRequest) => Promise<void>;
    disabled?: boolean;
}

const RequestConnectionButton = (props: RequestConnectionButtonProps) => {
    const { idAgency, onChangeLoading, onRequestSuccess, disabled } = props;
    const translate = useTranslate();
    const { setErrorMessage, setSuccessMessage } = useNotification();

    const handleRequestConnection = async () => {
        try {
            onChangeLoading(true);
            const { data } = await requestConnectionToMember(idAgency);
            if (data.Success && data.StatusCode === 200) {
                await onRequestSuccess(data.Result);
                setSuccessMessage(
                    FeedbackMessages.SUCCESSFUL_CONNECTION_REQUEST_SENT
                );
            } else {
                setErrorMessage(FeedbackMessages.ERROR_FETCHING);
            }
        } catch (error) {
            console.log({ error });
            setErrorMessage(FeedbackMessages.ERROR_FETCHING);
        } finally {
            onChangeLoading(false);
        }
    };

    return (
        <Button
            startIcon='Link'
            variant='contained'
            className='white-space-nowrap'
            style={{ height: '30px' }}
            onClick={handleRequestConnection}
            disabled={disabled}
        >
            {translate('request_connection')}
        </Button>
    );
};

export default RequestConnectionButton;
